import { Injectable } from '@angular/core'

import { last } from '@app/core/array/last'
import type { Message } from '@app/modules/messaging/models/message.model'

import { MessagingService } from '../../../services/messaging.service'

@Injectable({
  providedIn: 'root',
})
export class FollowUpBoostService {
  private static readonly FOLLOWUP_DELAY = 20 * 60 * 1000

  private static sliceOlderUnrepliedMessages(sortedMessages: Message[], firstNewMessage: Message): Message[] {
    const result: Message[] = []
    for (const message of [...sortedMessages].reverse()) {
      if (!message.is_me) {
        break
      }
      if (message.timestamp < firstNewMessage.timestamp) {
        result.unshift(message)
      }
    }
    return result
  }

  private static isDelayedEnough(a: Message, b: Message): boolean {
    const delayInMs = new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    return delayInMs >= FollowUpBoostService.FOLLOWUP_DELAY
  }

  private static hasAlreadyBeenShown(olderUnrepliedMessages: Message[]): boolean {
    if (olderUnrepliedMessages.length < 2) {
      return false
    }
    return olderUnrepliedMessages.some(
      message =>
        message.boosted ||
        (MessagingService.isBoostable(message) && this.isDelayedEnough(message, olderUnrepliedMessages[0])),
    )
  }

  static getMessageAllowedForFollowUp(newMessages: Message[], allMessages: Message[]): Message | undefined {
    const newestMessage = last(newMessages)
    if (!MessagingService.isBoostable(newestMessage)) {
      return undefined
    }
    const olderUnrepliedMessages = this.sliceOlderUnrepliedMessages(allMessages, newMessages[0])
    if (olderUnrepliedMessages.length === 0) {
      return undefined
    }
    if (!this.isDelayedEnough(newestMessage, olderUnrepliedMessages[0])) {
      return undefined
    }
    if (this.hasAlreadyBeenShown(olderUnrepliedMessages)) {
      return undefined
    }

    return newestMessage
  }
}
